import { render } from "./ChangePhoneNumber.vue?vue&type=template&id=1fc53dae&scoped=true"
import script from "./ChangePhoneNumber.vue?vue&type=script&lang=js"
export * from "./ChangePhoneNumber.vue?vue&type=script&lang=js"

import "./ChangePhoneNumber.vue?vue&type=style&index=0&id=1fc53dae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc53dae"]])

export default __exports__